export const contractTypes = {
    cdd: {
        name: 'CDD'
    },
    cdi: {
        name: 'CDI'
    },
    cee: {
        name: 'CEE'
    },
    other: {
        name: 'Autres'
    }
}

export const jobTitles = {
    holiday_stay_director: {
        name: 'Direction en ACM'
    },
    holiday_stay_leader: {
        name: 'Animation en ACM'
    },
    holiday_stay_leader_swimming_lifeguard: {
        name: 'Animation (surveillance des baignaides) en ACM'
    },
    holiday_stay_intern: {
        name: 'Animation (stage pratique) en ACM'
    },
    bafad_trainer: {
        name: 'Formation BAFA-BAFD'
    },
    bafad_director: {
        name: 'Direction BAFA-BAFD'
    },
    service_staff: {
        name: 'Personnel de service'
    },
    service_cook: {
        name: 'Cuisine'
    }
}

export const jobStatus = {
    permanent: {        
        name: 'Permanent',
        icon: 'fi fi-rr-briefcase'
    },
    seasonal: {
        name: 'Saisonnier',
        icon: 'fi fi-rr-backpack'
    }
}